export default function templateWaitlist(template, { isEditing, editedFields }) {
  if (isEditing) return {};
  const values = {
    waitlist_enabled: template.default_waitlist_enabled,
    waitlist_claim_window_hours: template.default_waitlist_claim_window_hours,
  };
  return Object.fromEntries(Object.entries(values).filter(([field]) => !editedFields.includes(field)));
}
